import * as ACTIONTYPES from '../constants/actiontypes';
import 'whatwg-fetch';
import AppApiUrl from '../../api/AppApiUrl';
import { getFetch } from '../../tools/fetch';


export const widgetInit = (initData) => (dispatch, getState) => {
  let isWidget = getState().app.isWidget;
  let isWidgetBooks = getState().app.isWidgetBooks;
  let isWidgetSubs = getState().app.isWidgetSubs;
  let isWidgetChannel = getState().app.isWidgetChannel;
  let isWidgetUser = getState().app.isWidgetUser;
  if (!isWidget) {
    isWidget = initData.wgt;
    isWidgetBooks = initData.wgtB;
    isWidgetChannel = initData.wgtC;
    isWidgetSubs = initData.wgtS;
    isWidgetUser = initData.wgtU;
  }

  if (isWidget) {
    dispatch(persistWidget(isWidget, isWidgetBooks, isWidgetChannel, isWidgetSubs, isWidgetUser));
  }
};

export const fetchWidget = () => (dispatch, getState) => {
  dispatch(showWidget());
  const state = getState();

  const channelId = state.app !== null && (state.app.isWidgetChannel || 1)

  const url = AppApiUrl.getWidgetInfoUrl(channelId);

  getFetch(url)
    .then(res => {
      dispatch(addWidgetData(res.data))
    })
    .catch(error => {
      console.log(error);
    });
};

export const showWidget = () => ({
  type: ACTIONTYPES.SHOW_WIDGET,
});

export const hideWidget = () => ({
  type: ACTIONTYPES.HIDE_WIDGET,
});

const addWidgetData = (widgetData) => ({
  type: ACTIONTYPES.ADD_WIDGET_DATA,
  widgetData,
});

const persistWidget = (isWidget, isWidgetBooks, isWidgetChannel, isWidgetSubs, isWidgetUser) => ({
  type: ACTIONTYPES.PERSIST_WIDGET,
  isWidget,
  isWidgetBooks,
  isWidgetChannel,
  isWidgetSubs,
  isWidgetUser
});


// WEBPACK FOOTER //
// ./src/store/actions/widget-actions.js